import components from './es-es/components'
import seo from './es-es/seo'
import pages from './es-es/pages'

export default {
  components,
  seo,
  pages,
}
